// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"VinInput_progressColor__1eZ6L","linkButtonWide":"VinInput_linkButtonWide__kNmBI","linkButtonThin":"VinInput_linkButtonThin__J-gBT"};